export default __webpack_public_path__ + "static/Vectorcircle-e0d399cb88a866aa76e454e4c96f8ab3.png";